/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

export enum ApplicationMetricsDataKey {
  /**
   * Time in milliseconds it takes to start app
   */
  APP_STARTUP_TIME = 'app_startup_time',
  /**
   * Time in milliseconds it takes to start app (NewRelic specific key)
   */
  TIME_TO_APP_START = 'time_to_app_start',
  /**
   * Time taken from app launch to splash screen render (metric event)
   */
  TIME_TO_SPLASH = 'time_to_splash',
}
